import { canTryInChat } from '@apps/web/features/learn_phoebe/model/access';
import { useOrganizationId } from '@apps/web/hooks/use_organization_id';
import { useOrganization } from '@apps/web/swr_data_fetching/data_fetching_hooks';

/**
 * Whether "Try in chat" can actually land.
 *
 * The action seeds the docked composer through UI context. If the org cannot
 * open the general chat at all, no chat view ever mounts to consume the draft,
 * so it would sit in provider state and later surface unprompted in the first
 * composer that does appear. Don't offer the action in that case — the prompt
 * is still readable and copyable on the page.
 */
export function useCanTryInChat(): boolean {
    const organizationId = useOrganizationId();
    const { data: organization } = useOrganization(organizationId, {
        reason: 'learn-phoebe-try-in-chat',
    });
    return canTryInChat(organization);
}
